const TAB_DEFS = {
  company: {
    path: '/settings/company',
    labelKey: 'settings.menu.company',
    roles: ['superadmin', 'owner', 'admin']
  },
  branches: {
    path: '/settings/branches',
    labelKey: 'settings.menu.branches',
    roles: ['owner', 'admin'],
    hideForChildHome: true
  },
  invoiceProvider: {
    path: '/settings/invoice-provider',
    labelKey: 'settings.menu.invoiceProvider',
    roles: ['superadmin', 'owner']
  },
  whatsapp: {
    path: '/settings/whatsapp',
    labelKey: 'settings.menu.whatsapp',
    roles: ['superadmin', 'owner']
  },
  tenantCredits: {
    path: '/settings/credits',
    labelKey: 'settings.menu.credits',
    roles: ['owner']
  },
  emailMailbox: {
    path: '/settings/email-mailbox',
    labelKey: 'settings.menu.emailMailbox',
    roles: ['superadmin', 'owner', 'admin', 'agent']
  },
  emailTemplates: {
    path: '/settings/email-templates',
    labelKey: 'settings.menu.emailTemplates',
    roles: ['superadmin', 'owner', 'admin', 'agent']
  },
  recordTypes: {
    path: '/settings/record-types',
    labelKey: 'settings.menu.recordTypes',
    roles: ['superadmin', 'owner', 'admin']
  }
};

export function getSettingsTabs(role, session) {
  return Object.values(TAB_DEFS).filter((tab) => {
    if (!tab.roles.includes(role)) return false;
    if (tab.hideForChildHome && session?.isHomeChild) return false;
    return true;
  });
}

export function resolveSettingsTabPath(pathname, role, session) {
  const tabs = [...getSettingsTabs(role, session)].sort((a, b) => b.path.length - a.path.length);
  return tabs.find((tab) => pathname === tab.path)?.path ?? null;
}

export function getDefaultSettingsPath(role, session) {
  return getSettingsTabs(role, session)[0]?.path ?? null;
}

export function isSettingsTabPath(pathname, role, session) {
  return resolveSettingsTabPath(pathname, role, session) !== null;
}
